
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.108 2.44a1.2 1.2 0 01.765.623c.58 1.16 1.014 1.865 1.45 2.436.44.578.907 1.052 1.617 1.761a8.378 8.378 0 012.46 5.94A8.4 8.4 0 116.06 7.26a1.2 1.2 0 012.049.849c0 1.344.084 2.367.477 3.184.216.45.553.888 1.134 1.28.139-1.273.393-2.824.736-4.296.27-1.159.607-2.316 1.008-3.28a8.4 8.4 0 01.683-1.34c.25-.386.572-.779.987-1.056a1.2 1.2 0 01.974-.16zm.438 15.705A3.6 3.6 0 018.4 15.6s1.054.6 3 .6c0-1.2.6-4.8 1.5-5.4.6 1.2.943 1.551 1.646 2.254A3.59 3.59 0 0115.6 15.6a3.59 3.59 0 01-1.054 2.545z","fill":"#fff"}})])
          )
        }
      }
    